import React from 'react'
import { ORIGIN_PM } from '../../../constants/metaMovieOrigins'
import Translation from '../../Translation/cont/Translation'


const SourceField = ({metaKey, metaValue, onReset}) => {
    const isCustom = metaValue === ORIGIN_PM
    const status = isCustom ? <Translation id="formik_sourcefield_custom" /> : <Translation id="formik_sourcefield_original" />

    return (
        <div className="source-field">
            <span className="source-text text-small-light"><Translation id="formik_sourcefield_source">Quelle</Translation>: {status}</span>
            {isCustom && <span className="reset-button text-small-regular cursor-pointer" onClick={() => onReset(metaKey)}><Translation id="formik_sourcefield_reset">Reset</Translation></span>}
        </div>
    )
}

export default SourceField